export default __webpack_public_path__ + "static/media/ovary_ng.2e348d82.jpg";